import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components-pages/services/EnterpriseResilience.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ContentIdeaPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ImageTextSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/PageSchemas.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ProcessSteps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/StructuredData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/UniversalPageHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/services/ConsultationCTA.tsx");
